import React, { useEffect, useState } from "react";
import "./Loader.scss";

const Loader: React.FC = () => {
  return (
    <div className="loader-wrapper">
      <div className="cargo-box" />
      <div className="truck">
        <div className="truck-body" />
        <div className="truck-cabin" />
        <div className="wheel front-wheel" />
        <div className="wheel back-wheel" />
      </div>
    </div>
  );
};

export default Loader;
